import { number, string, shape, arrayOf, objectOf, oneOfType, instanceOf, func, element, node, elementType, object } from 'prop-types';

export default {
  account: shape({ defaultProject: object }).isRequired,
  shipment: shape({
    id: oneOfType([number, string]),
    label: string,
    defaultDevices: arrayOf(shape({
      color: string,
      id: oneOfType([number, string]),
      measurements: arrayOf(objectOf(oneOfType([string, number]))),
      project: shape({
        id: oneOfType([number, string]),
        title: string
      }),
      title: string,
      uid: string
    }))
  }).isRequired,
  dateRange: arrayOf(oneOfType([instanceOf(Date), string])).isRequired,
  dispatch: func.isRequired,
  children: oneOfType([element, node, elementType]).isRequired
};
